// 對應 index.css 的 --wa-clay-red / --wa-gold / --wa-moss。元件跟測試都從這裡
// 取值，不要各自寫死字面色碼——全域色票調色時，只需要同步改這裡一處
// （加上 index.css 本身），不會有第三份散落在測試檔案裡的副本忘記改到。
export const ALERT_COLORS = {
  danger: "#B15D46",
  warning: "#C99A3E",
  normal: "#87976A",
};
